import { NavigateFunction, NavigateOptions, To } from 'react-router-dom';
import { formGuardStore } from '@/shared/lib/formGuardStore';

type SafeNavigate = (to: To, options?: NavigateOptions) => void;

/**
 * Обёртка над navigate, которая временно разрешает навигацию,
 * обходя глобальный блокер несохранённых данных.
 *
 * 1. allowNavigation = true
 * 2. navigate(to)
 * 3. allowNavigation = false
 */
export const createSafeNavigate = (navigate: NavigateFunction): SafeNavigate => {
  return (to, options) => {
    formGuardStore.setState({ allowNavigation: true });
    navigate(to, options);
    formGuardStore.setState({ allowNavigation: false });
  };
};
